import { Breakpoints } from './enums';

export const mediaQueries = {
  mobile: `@media (max-width: ${Breakpoints.tablet - 1}px)`,
  tablet: `@media (min-width: ${Breakpoints.tablet}px) and (max-width: ${Breakpoints.desktop - 1}px)`,
  desktop: `@media (min-width: ${Breakpoints.desktop}px)`,
  mobileAndTablet: `@media (max-width: ${Breakpoints.desktop - 1}px)`,
  tabletAndDesktop: `@media (min-width: ${Breakpoints.tablet}px)`
};

export const heightQueries = {
  minHeight: (minHeight: number) => `@media (min-height: ${minHeight}px)`,
  maxHeight: (maxHeight: number) => `@media (max-height: ${maxHeight}px)`
};
